(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["charm-addon"] && !Shopify.designMode) return;
  try {
    (function () {
    var SIZE_RE = /size/i;
    var COLOR_RE = /colou?r/i;

    function money(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        try { return Shopify.formatMoney(cents, window.PP_MONEY_FORMAT); } catch (e) {}
      }
      return '$' + (cents / 100).toFixed(2);
    }
    function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }
    function optionNames(p) {
      return (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    }
    function indexOf(names, re) {
      for (var i = 0; i < names.length; i++) if (re.test(names[i])) return i;
      return -1;
    }
    function vOpts(v) {
      if (v.options && v.options.length) return v.options;
      return [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
    }

    function init(root) {
      if (root.dataset.chadReady === '1') return;
      root.dataset.chadReady = '1';

      var form = root.closest('form');
      var toggle = root.querySelector('[data-chad-toggle]');
      var priceEl = root.querySelector('[data-chad-price]');
      var sizeEl = root.querySelector('[data-chad-size]');
      var errorEl = root.querySelector('[data-chad-error]');
      var letterSel = root.querySelector('[data-chad-letter]');
      var colourSel = root.querySelector('[data-chad-colour]');
      var qtyInput = root.querySelector('[data-chad-qty]');
      var mode = root.getAttribute('data-mode');
      var propLetter = root.getAttribute('data-prop-letter');
      var propColour = root.getAttribute('data-prop-colour');
      if (!form || !toggle) return;

      var addon = null;
      var chosen = null;
      var json = root.querySelector('[data-chad-json]');
      if (json) { try { addon = JSON.parse(json.textContent); } catch (e) { addon = null; } }
      if (!addon) { root.hidden = true; return; }

      /* The main product's selected Size, read off its option radios. */
      function mainSize() {
        var inputs = form.querySelectorAll('[data-product-option]');
        for (var i = 0; i < inputs.length; i++) {
          var inp = inputs[i];
          if (inp.checked && SIZE_RE.test(inp.getAttribute('data-option-name') || '')) return inp.value;
        }
        return null;
      }

      function qty() {
        if (!qtyInput) return 1;
        var n = parseInt(qtyInput.value, 10);
        if (isNaN(n)) n = 1;
        n = Math.min(5, Math.max(1, n));
        qtyInput.value = n;
        return n;
      }

      /* Size must match; in letters mode the colour picks the variant too.
         Before a colour is chosen, any colour in that size stands in for the
         price, which is the same across colours in this catalogue. */
      function resolve() {
        var names = optionNames(addon);
        var iSize = indexOf(names, SIZE_RE);
        var iColour = mode === 'letters' ? indexOf(names, COLOR_RE) : -1;
        var size = mainSize();
        var colour = colourSel ? colourSel.value : '';
        var list = (addon.variants || []).filter(function (v) { return v.available; });
        var sized = list.filter(function (v) {
          return iSize === -1 || !size || norm(vOpts(v)[iSize]) === norm(size);
        });
        if (!sized.length) return null;
        if (iColour > -1 && colour) {
          var exact = sized.filter(function (v) { return norm(vOpts(v)[iColour]) === norm(colour); });
          return { variant: exact[0] || null, size: size, pending: false, missing: !exact.length };
        }
        return { variant: sized[0], size: size, pending: iColour > -1, missing: false };
      }

      function render() {
        chosen = resolve();
        if (!chosen) { root.hidden = true; toggle.checked = false; syncExpress(); return; }
        root.hidden = false;
        var v = chosen.variant;
        var n = qty();
        if (priceEl) {
          priceEl.textContent = v ? '· ' + money(v.price) + (n > 1 ? ' ' + (root.getAttribute('data-each') || 'each') : '') : '';
        }
        if (sizeEl) {
          if (chosen.size) {
            sizeEl.hidden = false;
            sizeEl.textContent = (root.getAttribute('data-size-note') || 'Size %s').replace('%s', chosen.size);
          } else {
            sizeEl.hidden = true;
          }
        }
      }

      function setError(msg, field) {
        [letterSel, colourSel].forEach(function (s) { if (s) { s.classList.remove('has-error'); s.removeAttribute('aria-invalid'); } });
        if (!errorEl) return;
        if (!msg) { errorEl.hidden = true; errorEl.textContent = ''; return; }
        errorEl.hidden = false;
        errorEl.textContent = msg;
        if (field) {
          field.classList.add('has-error');
          field.setAttribute('aria-invalid', 'true');
          try { field.focus({ preventScroll: false }); } catch (e) {}
        }
      }

      function validAddon() {
        if (letterSel && !letterSel.value) { setError(root.getAttribute('data-error-letter'), letterSel); return false; }
        if (colourSel && !colourSel.value) { setError(root.getAttribute('data-error-colour'), colourSel); return false; }
        if (!chosen || !chosen.variant) { setError(root.getAttribute('data-error-colour'), colourSel); return false; }
        setError('');
        return true;
      }

      /* The main line, exactly as the plain form would have sent it. */
      function mainLine() {
        var fd = new FormData(form);
        var line = { id: parseInt(fd.get('id'), 10), quantity: Math.max(1, parseInt(fd.get('quantity'), 10) || 1) };
        var props = {};
        fd.forEach(function (val, key) {
          if (key.indexOf('properties[') === 0 && typeof val === 'string' && val.trim()) {
            props[key.slice(11, -1)] = val.trim();
          }
        });
        if (Object.keys(props).length) line.properties = props;
        return line;
      }

      function addonLine() {
        var line = { id: chosen.variant.id, quantity: mode === 'extra' ? qty() : 1 };
        if (mode === 'extra') {
          line.properties = {};
          line.properties[propLetter] = letterSel.value;
          line.properties[propColour] = colourSel.value;
        }
        return line;
      }

      async function addBoth(button) {
        var rootUrl = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        if (button) { button.classList.add('is-loading'); button.disabled = true; }
        try {
          var res = await fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [mainLine(), addonLine()], sections: 'cart-drawer', sections_url: window.location.pathname }),
          });
          var data = await res.json();
          if (data.status) { setError(data.description || 'Unavailable'); return; }
          var Cart = window.PawsomeCart;
          if (Cart) {
            Cart.applySections(data.sections);
            await Cart.refresh(false);
            Cart.open();
          } else {
            window.location.href = rootUrl + 'cart';
          }
        } catch (e) {
          setError('Something went wrong. Please try again.');
        } finally {
          if (button) { button.classList.remove('is-loading'); button.disabled = false; }
        }
      }

      /* Target phase on the form: runs before the document-level AJAX handler,
         so a ticked box takes the submit over. The main product's own
         required-field guards run first and still win. */
      form.addEventListener('submit', function (event) {
        if (!toggle.checked || root.hidden) return;
        event.preventDefault();
        event.stopPropagation();
        var guards = [window.PawsomePetName, window.PawsomeCharmColour, window.PawsomeCharmLetter];
        for (var i = 0; i < guards.length; i++) {
          if (guards[i] && guards[i].validate && !guards[i].validate(form)) return;
        }
        if (!validAddon()) return;
        addBoth(form.querySelector('[type="submit"]'));
      });

      /* Choosing a letter or colour in the add-on is a clear yes to it. */
      function onPick() {
        if (!toggle.checked) { toggle.checked = true; syncExpress(); }
        setError('');
        render();
      }
      [letterSel, colourSel].forEach(function (s) {
        if (!s) return;
        s.addEventListener('change', function (e) { e.stopPropagation(); onPick(); });
      });

      if (qtyInput) {
        root.querySelectorAll('[data-chad-step]').forEach(function (b) {
          b.addEventListener('click', function () {
            qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-chad-step'), 10);
            qty();
            render();
          });
        });
        qtyInput.addEventListener('change', function (e) { e.stopPropagation(); qty(); render(); });
      }

      toggle.addEventListener('change', function () { if (!toggle.checked) setError(''); syncExpress(); });

      /* Size switched on the main product → re-match the add-on. */
      form.addEventListener('change', function (e) {
        if (e.target.closest && e.target.closest('[data-product-option]')) render();
      });

      /* Express checkout posts only this form's variant; hide it while ticked. */
      function syncExpress() {
        var express = form.querySelector('.pdp__express');
        if (express) express.hidden = toggle.checked;
      }

      render();
      syncExpress();
    }

    function initAll() {
      var nodes = document.querySelectorAll('[data-charm-addon]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["charm-colour"] && !Shopify.designMode) return;
  try {
    /* Blocks add-to-cart until a charm colour is chosen.

     The guard sits on the FORM's submit event, at the target phase, so it runs
     before the document-level AJAX cart handler and also catches the sticky
     mobile bar (which calls requestSubmit() on this same form). Native
     validation is switched off so the inline, on-brand message owns the UX
     instead of the browser's bubble. */
  (function () {
    function errorNode(root) { return root.querySelector('[data-charm-colour-error]'); }

    function show(root, select) {
      var e = errorNode(root);
      if (e) e.hidden = false;
      select.classList.add('has-error');
      select.setAttribute('aria-invalid', 'true');
    }
    function hide(root, select) {
      var e = errorNode(root);
      if (e) e.hidden = true;
      select.classList.remove('has-error');
      select.removeAttribute('aria-invalid');
    }
    function reduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    /* Exposed so other PDP scripts can reuse it rather than depending on the
       order submit listeners happen to be bound in. */
    function validateForm(form) {
      if (!form) return true;
      var root = form.querySelector('[data-charm-colour]');
      if (!root) return true;
      var select = root.querySelector('[data-charm-colour-select]');
      if (!select) return true;
      if (select.value) { hide(root, select); return true; }
      show(root, select);
      try { select.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) {}
      select.focus({ preventScroll: true });
      return false;
    }
    window.PawsomeCharmColour = { validate: validateForm };

    function init(root) {
      if (root.dataset.charmReady === '1') return;
      root.dataset.charmReady = '1';
      var select = root.querySelector('[data-charm-colour-select]');
      if (!select) return;

      select.addEventListener('change', function () { if (select.value) hide(root, select); });

      var form = select.closest('form');
      if (!form) return;
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (event) {
        if (validateForm(form)) return;
        event.preventDefault();
        event.stopPropagation();
      });
    }

    function initAll() {
      var nodes = document.querySelectorAll('[data-charm-colour]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["charm-colours-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    function modal() { return document.querySelector('[data-charm-colours-modal]'); }
    var opener = null;

    /* Start the download instead of waiting for the sheet to be painted. */
    function warm(dlg) {
      var img = (dlg || document).querySelector('[data-charm-colours-img]');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }
    /* First touch/hover on any trigger is enough warning. */
    ['pointerdown', 'pointerenter', 'focusin'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target.closest && e.target.closest('[data-charm-colours-open]')) warm(modal());
      }, true);
    });

    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-charm-colours-open]');
      var dlg = modal();
      if (open && dlg) {
        e.preventDefault();
        opener = open;
        warm(dlg);
        /* A transformed ancestor (the reveal animations use transform) becomes
           the containing block for position: fixed, which pushed the sheet's
           bottom edge past the viewport. Re-parenting to <body> once puts it
           back on the viewport. */
        if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
        if (!dlg.open) {
          if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        }
        return;
      }
      if (!dlg || !dlg.open) return;
      /* Close button, or a tap on the backdrop (the dialog box itself, outside the panel). */
      if (e.target.closest('[data-charm-colours-close]') || e.target === dlg) {
        if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
      }
    });

    /* Esc is native to showModal(); this only returns focus to the link. */
    document.addEventListener('close', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-charm-colours-modal]') && opener) {
        try { opener.focus({ preventScroll: true }); } catch (err) {}
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["charm-letter"] && !Shopify.designMode) return;
  try {
    /* Blocks add-to-cart until a letter is chosen.

     The guard sits on the FORM's submit event so it runs before the
     document-level AJAX cart handler, and so the sticky mobile bar is covered
     too — that button calls requestSubmit() on this same form rather than
     posting on its own. Native validation is switched off so the inline,
     on-brand message owns the UX instead of the browser's bubble.

     A product can carry both this field and the charm-colour one; the two
     guards are independent and each blocks on its own, so the shopper is sent
     to whichever is still empty. */
  (function () {
    function errorNode(root) { return root.querySelector('[data-charm-letter-error]'); }

    function show(root, select) {
      var e = errorNode(root);
      if (e) e.hidden = false;
      select.classList.add('has-error');
      select.setAttribute('aria-invalid', 'true');
    }
    function hide(root, select) {
      var e = errorNode(root);
      if (e) e.hidden = true;
      select.classList.remove('has-error');
      select.removeAttribute('aria-invalid');
    }
    function reduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    /* Exposed so other PDP scripts can reuse it rather than depending on the
       order submit listeners happen to be bound in. */
    function validateForm(form) {
      if (!form) return true;
      var root = form.querySelector('[data-charm-letter]');
      if (!root) return true;
      var select = root.querySelector('[data-charm-letter-select]');
      if (!select) return true;
      if (select.value) { hide(root, select); return true; }
      show(root, select);
      try { select.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) {}
      select.focus({ preventScroll: true });
      return false;
    }
    window.PawsomeCharmLetter = { validate: validateForm };

    function init(root) {
      if (root.dataset.charmLetterReady === '1') return;
      root.dataset.charmLetterReady = '1';
      var select = root.querySelector('[data-charm-letter-select]');
      if (!select) return;

      select.addEventListener('change', function () { if (select.value) hide(root, select); });

      var form = select.closest('form');
      if (!form) return;
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (event) {
        if (validateForm(form)) return;
        event.preventDefault();
        event.stopPropagation();
      });
    }

    function initAll() {
      var nodes = document.querySelectorAll('[data-charm-letter]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["engraving-fields"] && !Shopify.designMode) return;
  try {
    /* Engraving fields — live nameplate preview, character counters, input
     sanitising and an add-to-cart guard that also covers the sticky mobile bar
     (the sticky button calls requestSubmit() on this same form). */
  (function () {
    var NAME_OK = /[^A-Za-z \-'.&]/g;
    var PHONE_OK = /[^0-9 +()\-]/g;
    var HAS_LETTER = /[A-Za-z]/;

    function initEngrave(root) {
      if (!root || root.dataset.engraveReady === '1') return;
      root.dataset.engraveReady = '1';

      var nameInput = root.querySelector('[data-engrave-name]');
      var phoneInput = root.querySelector('[data-engrave-phone]');
      var previewName = root.querySelector('[data-engrave-preview-name]');
      var previewPhone = root.querySelector('[data-engrave-preview-phone]');
      var countName = root.querySelector('[data-engrave-count-name]');
      var countPhone = root.querySelector('[data-engrave-count-phone]');
      var errName = root.querySelector('[data-engrave-error]');
      var errPhone = root.querySelector('[data-engrave-error-phone]');
      var phoneRequired = root.getAttribute('data-phone-required') === 'true';
      var placeholder = previewName ? previewName.textContent : '';
      if (!nameInput) return;

      /* Strips disallowed characters (emoji included) and enforces the length
         cap without throwing the caret to the end of the field. */
      function clean(input, pattern, upper) {
        var before = input.value;
        var after = before.replace(pattern, '');
        if (upper) after = after.toUpperCase();
        var max = parseInt(input.getAttribute('data-max'), 10) || 0;
        if (max && after.length > max) after = after.slice(0, max);
        if (after !== before) {
          var pos = input.selectionStart;
          var removed = before.length - after.length;
          input.value = after;
          try { input.setSelectionRange(pos - removed, pos - removed); } catch (e) {}
        }
        return after;
      }

      function count(el, value, max) {
        if (!el) return;
        el.textContent = value.length + ' / ' + max;
        el.classList.toggle('is-full', max > 0 && value.length >= max);
      }

      function syncName() {
        var value = clean(nameInput, NAME_OK, true);
        count(countName, value, parseInt(nameInput.getAttribute('data-max'), 10) || 0);
        if (previewName) {
          var trimmed = value.trim();
          previewName.textContent = trimmed || placeholder;
          previewName.classList.toggle('is-placeholder', !trimmed);
        }
        if (trimmedValid(value)) hideError(nameInput, errName);
      }

      function syncPhone() {
        if (!phoneInput) return;
        var value = clean(phoneInput, PHONE_OK, false);
        count(countPhone, value, parseInt(phoneInput.getAttribute('data-max'), 10) || 0);
        if (previewPhone) {
          var trimmed = value.trim();
          previewPhone.textContent = trimmed;
          previewPhone.hidden = !trimmed;
        }
        if (!phoneRequired || value.trim()) hideError(phoneInput, errPhone);
      }

      function trimmedValid(value) {
        var v = (value || '').trim();
        return v.length > 0 && HAS_LETTER.test(v);
      }

      function showError(input, node) {
        if (node) node.hidden = false;
        if (input) {
          input.classList.add('has-error');
          input.setAttribute('aria-invalid', 'true');
        }
      }

      function hideError(input, node) {
        if (node) node.hidden = true;
        if (input) {
          input.classList.remove('has-error');
          input.removeAttribute('aria-invalid');
        }
      }

      nameInput.addEventListener('input', syncName);
      nameInput.addEventListener('blur', syncName);
      if (phoneInput) {
        phoneInput.addEventListener('input', syncPhone);
        phoneInput.addEventListener('blur', syncPhone);
      }
      syncName();
      syncPhone();

      /* Guard the add-to-cart. The listener sits on the form itself, so it runs
         at the target phase — before the document-level AJAX cart handler. */
      var form = nameInput.closest('form');
      if (!form) return;
      form.setAttribute('novalidate', 'novalidate'); /* JS owns validation now */
      form.addEventListener('submit', function (event) {
        var bad = null;
        if (phoneRequired && phoneInput && !phoneInput.value.trim()) {
          showError(phoneInput, errPhone);
          bad = phoneInput;
        }
        if (!trimmedValid(nameInput.value)) {
          showError(nameInput, errName);
          bad = nameInput;
        }
        if (!bad) return;
        event.preventDefault();
        event.stopPropagation();
        try { bad.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
        bad.focus({ preventScroll: true });
      });
    }

    function initAll() {
      var nodes = document.querySelectorAll('[data-engrave]');
      for (var i = 0; i < nodes.length; i++) initEngrave(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["match-upsell"] && !Shopify.designMode) return;
  try {
    /* Matching collar/leash upsell.

     Responsibilities:
       1. Resolve the partner product (inline JSON, or a fetch when it was not
          visible to Liquid at render time) and reveal the row only if it has at
          least one buyable variant.
       2. Keep the partner variant in sync with the colour (and size) selected
          on this PDP, falling back to the nearest available colour with a note.
       3. On add-to-cart, when the box is ticked, post BOTH lines in one
          /cart/add.js call and hand the response to the theme's cart drawer. */
  (function () {
    var COLOR_RE = /colou?r/i;
    var SIZE_RE = /size/i;

    /* Mirrors the theme.js helper — same format global, same fallback. */
    function money(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        try { return Shopify.formatMoney(cents, window.PP_MONEY_FORMAT); } catch (e) {}
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function norm(s) {
      return String(s == null ? '' : s).trim().toLowerCase();
    }

    /* Index of the option carrying colour (or size) on a product-ish object. */
    function optionIndex(optionNames, re) {
      for (var i = 0; i < optionNames.length; i++) {
        if (re.test(optionNames[i])) return i;
      }
      return -1;
    }

    /* Liquid's `product | json` gives option names as plain strings;
       /products/<handle>.js gives objects. Accept both. */
    function optionNamesOf(p) {
      var names = [];
      var opts = p && p.options ? p.options : [];
      for (var i = 0; i < opts.length; i++) {
        names.push(typeof opts[i] === 'string' ? opts[i] : (opts[i] && opts[i].name) || '');
      }
      return names;
    }

    /* Same story for the per-variant values: fall back to option1..3 if the
       flat `options` array is not in the payload. */
    function variantOptions(v) {
      if (v && v.options && v.options.length) return v.options;
      var out = [];
      for (var i = 1; i <= 3; i++) {
        var val = v ? v['option' + i] : null;
        if (val != null) out.push(val);
      }
      return out;
    }

    /* Cheap "nearest colour" ranking: exact, then one name containing the
       other, then shared words, then shared leading characters. Good enough to
       put "Dark Blue" next to "Blue" without pulling in a colour library. */
    function similarity(a, b) {
      a = norm(a); b = norm(b);
      if (!a || !b) return 0;
      if (a === b) return 1000;
      if (a.indexOf(b) !== -1 || b.indexOf(a) !== -1) return 800;
      var aw = a.split(/[^a-z0-9]+/).filter(Boolean);
      var bw = b.split(/[^a-z0-9]+/).filter(Boolean);
      var shared = 0;
      for (var i = 0; i < aw.length; i++) if (bw.indexOf(aw[i]) !== -1) shared++;
      if (shared) return 500 + shared;
      var n = Math.min(a.length, b.length), pre = 0;
      while (pre < n && a[pre] === b[pre]) pre++;
      return pre;
    }

    function initMatchup(root) {
      if (!root || root.dataset.matchupReady === '1') return;
      root.dataset.matchupReady = '1';

      var form = root.closest('form');
      var toggle = root.querySelector('[data-matchup-toggle]');
      var priceEl = root.querySelector('[data-matchup-price]');
      var noteEl = root.querySelector('[data-matchup-note]');
      var mediaEl = root.querySelector('[data-matchup-media]');
      var handle = root.getAttribute('data-partner-handle');
      var kind = root.getAttribute('data-partner-kind') || 'item';
      var shareName = root.getAttribute('data-share-name') === 'true';
      if (!form || !toggle || !handle) return;

      var partner = null;
      var chosen = null; /* the partner variant currently matched */

      var inline = root.querySelector('[data-matchup-json]');
      if (inline) {
        try { partner = JSON.parse(inline.textContent); } catch (e) { partner = null; }
      }

      /* ---- what did the shopper pick on THIS product? ---- */
      function selectedOptions() {
        var picked = [];
        var inputs = form.querySelectorAll('[data-product-option]');
        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];
          if (!input.checked) continue;
          var pos = parseInt((input.name || '').replace('option', ''), 10);
          if (pos > 0) picked[pos - 1] = input.value;
        }
        return picked;
      }

      /* Read the option names off the radios themselves, keyed by option
         position — NOT off the visible legends. The picker suppresses the
         label for any option with a single value, so the legend list no longer
         lines up with option1..N; the radios always do. */
      function mainOptionNames() {
        var names = [];
        var inputs = form.querySelectorAll('[data-product-option]');
        for (var i = 0; i < inputs.length; i++) {
          var pos = parseInt(inputs[i].getAttribute('data-option-position'), 10) ||
                    parseInt((inputs[i].name || '').replace('option', ''), 10);
          if (pos > 0) names[pos - 1] = inputs[i].getAttribute('data-option-name') || '';
        }
        return names;
      }

      /* ---- pick the partner variant that matches ---- */
      function resolve() {
        if (!partner || !partner.variants) return null;

        var partnerNames = optionNamesOf(partner);
        var pColor = optionIndex(partnerNames, COLOR_RE);
        var pSize = optionIndex(partnerNames, SIZE_RE);

        var mainNames = mainOptionNames();
        var picked = selectedOptions();
        var mColor = optionIndex(mainNames, COLOR_RE);
        var mSize = optionIndex(mainNames, SIZE_RE);

        var wantColor = mColor > -1 ? picked[mColor] : null;
        var wantSize = mSize > -1 ? picked[mSize] : null;

        var available = partner.variants.filter(function (v) { return v.available; });
        if (!available.length) return null;

        /* No colour to match on either side — just take the first buyable one. */
        if (pColor === -1 || !wantColor) {
          return { variant: available[0], exact: true, color: null, asked: null };
        }

        function sizeBonus(opts) {
          if (pSize === -1 || !wantSize) return 0;
          return norm(opts[pSize]) === norm(wantSize) ? 1 : 0;
        }

        var best = null, bestColor = null, bestScore = -1;
        for (var i = 0; i < available.length; i++) {
          var v = available[i];
          var opts = variantOptions(v);
          var score = similarity(opts[pColor], wantColor) * 10 + sizeBonus(opts);
          if (score > bestScore) { bestScore = score; best = v; bestColor = opts[pColor]; }
        }
        if (!best) return null;

        return {
          variant: best,
          exact: norm(bestColor) === norm(wantColor),
          color: bestColor,
          asked: wantColor,
        };
      }

      function render() {
        chosen = resolve();

        if (!chosen) {
          root.hidden = true;
          toggle.checked = false;
          toggle.disabled = true;
          return;
        }

        root.hidden = false;
        toggle.disabled = false;

        if (priceEl) priceEl.textContent = '· ' + money(chosen.variant.price);

        if (noteEl) {
          if (chosen.exact || !chosen.color) {
            noteEl.hidden = true;
            noteEl.textContent = '';
          } else {
            /* Covers both "that colour was never offered on the partner" and
               "it is offered but sold out" — the shopper only cares that it is
               not coming, and which colour is. */
            var asked = chosen.asked ? chosen.asked + ' isn’t' : 'That colour isn’t';
            noteEl.hidden = false;
            noteEl.textContent =
              asked + ' available on the ' + kind + ', so we’ll send the closest match, ' + chosen.color + '.';
          }
        }

        if (mediaEl && !mediaEl.querySelector('img')) {
          var src = partner.featured_image;
          if (src && typeof src === 'object') src = src.src || src.url;
          if (src) {
            if (src.indexOf('//') === 0) src = 'https:' + src;
            var img = document.createElement('img');
            img.src = src;
            img.alt = '';
            img.width = 56;
            img.height = 56;
            img.loading = 'lazy';
            mediaEl.innerHTML = '';
            mediaEl.appendChild(img);
          }
        }
      }

      /* ---- add both lines in one call ---- */
      function collectProperties() {
        var props = {};
        var inputs = form.querySelectorAll('[name^="properties["]');
        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];
          if (input.type === 'checkbox' && !input.checked) continue;
          var key = input.name.slice('properties['.length, -1);
          if (input.value && input.value.trim()) props[key] = input.value.trim();
        }
        return props;
      }

      function quantity() {
        var qty = form.querySelector('[name="quantity"]');
        return Math.max(1, parseInt(qty ? qty.value : '1', 10) || 1);
      }

      function mainVariantId() {
        var el = form.querySelector('[data-variant-id]') || form.querySelector('[name="id"]');
        return el ? parseInt(el.value, 10) : null;
      }

      async function addBoth(button) {
        var id = mainVariantId();
        if (!id || !chosen) return false;

        var props = collectProperties();
        var items = [{ id: id, quantity: quantity() }];
        if (Object.keys(props).length) items[0].properties = props;

        var partnerLine = { id: chosen.variant.id, quantity: 1 };
        if (shareName && props["Pet's Name"]) {
          partnerLine.properties = { "Pet's Name": props["Pet's Name"] };
        }
        items.push(partnerLine);

        var root_url = window.Shopify ? Shopify.routes.root : '/';
        if (button) { button.classList.add('is-loading'); button.disabled = true; }
        try {
          var res = await fetch(root_url + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: items,
              sections: 'cart-drawer',
              sections_url: window.location.pathname,
            }),
          });
          var data = await res.json();
          if (data.status) {
            if (button) button.textContent = data.description || 'Unavailable';
            return true;
          }
          var Cart = window.PawsomeCart;
          if (Cart) {
            Cart.applySections(data.sections);
            await Cart.refresh(false);
            Cart.open();
          } else {
            window.location.href = root_url + 'cart';
          }
        } catch (e) {
          if (button) button.textContent = 'Try again';
        } finally {
          if (button) { button.classList.remove('is-loading'); button.disabled = false; }
        }
        return true;
      }

      /* Target-phase listener: runs before the document-level AJAX cart
         handler, so we can take over the submit entirely when the box is on. */
      form.addEventListener('submit', function (event) {
        if (!toggle.checked || toggle.disabled || root.hidden || !chosen) return;

        /* Never bypass the pet-name guard — it may be bound after us. */
        var guard = window.PawsomePetName;
        if (guard && !guard.validate(form)) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        addBoth(form.querySelector('[type="submit"]'));
      });

      form.addEventListener('change', function (event) {
        if (event.target === toggle) { syncExpress(); return; }
        if (event.target.closest('[data-product-option]') || event.target.matches('select')) render();
      });

      /* The dynamic-checkout buttons post straight to checkout with this form's
         single variant, so a ticked partner would be silently dropped. Hide
         them while the box is on. (On the DIY sets they are already hidden —
         those products are tagged `personalized` — this keeps the row safe if
         it is ever pointed at a product where they do show.) */
      function syncExpress() {
        var express = form.querySelector('.pdp__express');
        if (express) express.hidden = toggle.checked;
      }
      syncExpress();

      /* ---- hydrate a partner Liquid could not see (draft / unpublished) ---- */
      if (partner) {
        render();
      } else {
        /* Keep the skeleton's checkbox inert until something actually resolves,
           so it can never be reached even if the row is force-shown. */
        toggle.disabled = true;
        fetch((window.Shopify ? Shopify.routes.root : '/') + 'products/' + handle + '.js', {
          headers: { Accept: 'application/json' },
        })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            if (!data || !data.available) return;
            partner = data;
            render();
          })
          .catch(function () { /* partner is unavailable — row stays hidden */ });
      }
    }

    function initAll() {
      var nodes = document.querySelectorAll('[data-matchup]');
      for (var i = 0; i < nodes.length; i++) initMatchup(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pet-name-field"] && !Shopify.designMode) return;
  try {
    /* Pet-name field — character counter, input sanitising and an add-to-cart
     guard that also covers the sticky mobile bar (that button calls
     requestSubmit() on this same form).

     Native `required` + `pattern` do the work when JS is unavailable; once this
     runs we take the form off native validation so the inline, on-brand error
     owns the UX instead of the browser bubble. */
  (function () {
    var DISALLOWED = /[^A-Za-z ]/g;
    var PHONE_OK = /[^0-9 +()\-]/g;
    var HAS_LETTER = /[A-Za-z]/;

    function reducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function isValid(value) {
      var v = (value || '').trim();
      return v.length > 0 && HAS_LETTER.test(v);
    }

    /* `photo:on` products are "name OR photo": a chosen image satisfies the
       guard on its own. */
    function hasPhoto(form) {
      var file = form.querySelector('[data-petname-photo]');
      return !!(file && file.files && file.files.length > 0);
    }

    function errorNode(input) {
      var root = input.closest('[data-petname]');
      return root ? root.querySelector('[data-petname-error]') : null;
    }

    function showError(input) {
      var node = errorNode(input);
      if (node) node.hidden = false;
      input.classList.add('has-error');
      input.setAttribute('aria-invalid', 'true');
    }

    function hideError(input) {
      var node = errorNode(input);
      if (node) node.hidden = true;
      input.classList.remove('has-error');
      input.removeAttribute('aria-invalid');
    }

    /* Shared guard. Returns true when the form may be submitted — i.e. it has
       no pet-name field at all, or the field is filled in. On failure it
       surfaces the inline error and moves focus. Exposed on `window` so other
       PDP scripts (the matching collar/leash upsell) can reuse it without
       depending on the order the submit listeners happen to be bound in. */
    function validateForm(form) {
      if (!form) return true;
      var input = form.querySelector('[data-petname-input]');
      if (!input) return true;
      if (isValid(input.value)) return true;
      if (hasPhoto(form)) { hideError(input); return true; }
      showError(input);
      try {
        input.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
      } catch (e) {}
      input.focus({ preventScroll: true });
      return false;
    }

    window.PawsomePetName = { validate: validateForm, isValid: isValid };

    function initPetName(root) {
      if (!root || root.dataset.petnameReady === '1') return;
      root.dataset.petnameReady = '1';

      var input = root.querySelector('[data-petname-input]');
      var countEl = root.querySelector('[data-petname-count]');
      if (!input) return;

      /* Present only on products tagged `phone:on`. Optional, so it never
         gates add-to-cart — it just gets the same sanitising and counter. */
      var phoneInput = root.querySelector('[data-petname-phone]');
      var phoneCountEl = root.querySelector('[data-petname-count-phone]');

      var max = parseInt(input.getAttribute('data-max'), 10) || 0;

      /* Strips disallowed characters (emoji included) and enforces the length
         cap without throwing the caret to the end of the field. */
      function clean(el, pattern, upper) {
        var before = el.value;
        var after = before.replace(pattern, '');
        if (upper) after = after.toUpperCase();
        var cap = parseInt(el.getAttribute('data-max'), 10) || 0;
        if (cap && after.length > cap) after = after.slice(0, cap);
        if (after !== before) {
          var pos = el.selectionStart;
          var removed = before.length - after.length;
          el.value = after;
          try { el.setSelectionRange(pos - removed, pos - removed); } catch (e) {}
        }
        return after;
      }

      function count(el, value, cap) {
        if (!el) return;
        el.textContent = value.length + ' / ' + cap;
        el.classList.toggle('is-full', cap > 0 && value.length >= cap);
      }

      function sync() {
        var value = clean(input, DISALLOWED, true);
        count(countEl, value, max);
        if (isValid(value)) hideError(input);
      }

      function syncPhone() {
        if (!phoneInput) return;
        var value = clean(phoneInput, PHONE_OK, false);
        count(phoneCountEl, value, parseInt(phoneInput.getAttribute('data-max'), 10) || 0);
      }

      /* Present only on products tagged `photo:on`. Validates type + size on
         pick; an oversize or non-image file is rejected and cleared so it can
         never reach the cart. */
      var photoInput = root.querySelector('[data-petname-photo]');
      var photoPicked = root.querySelector('[data-petname-photo-picked]');
      var photoRemove = root.querySelector('[data-petname-photo-remove]');
      var photoError = root.querySelector('[data-petname-photo-error]');

      function photoFail(kind) {
        if (!photoError) return;
        photoError.textContent = photoError.getAttribute('data-msg-' + kind) || '';
        photoError.hidden = false;
        photoInput.classList.add('has-error');
      }

      function syncPhoto() {
        if (!photoInput) return;
        var file = photoInput.files && photoInput.files[0];
        if (photoError) photoError.hidden = true;
        photoInput.classList.remove('has-error');
        if (file) {
          var maxBytes = parseInt(photoInput.getAttribute('data-max-bytes'), 10) || 0;
          if (file.type && file.type.indexOf('image/') !== 0) { photoInput.value = ''; file = null; photoFail('type'); }
          else if (maxBytes && file.size > maxBytes) { photoInput.value = ''; file = null; photoFail('size'); }
        }
        if (photoPicked) photoPicked.hidden = !file;
        if (file) hideError(input);
      }

      if (photoInput) {
        photoInput.addEventListener('change', syncPhoto);
        if (photoRemove) photoRemove.addEventListener('click', function () {
          photoInput.value = '';
          syncPhoto();
          photoInput.focus();
        });
        syncPhoto();
      }

      input.addEventListener('input', sync);
      input.addEventListener('blur', sync);
      if (phoneInput) {
        phoneInput.addEventListener('input', syncPhone);
        phoneInput.addEventListener('blur', syncPhone);
      }
      sync();
      syncPhone();

      /* Guard the add-to-cart. The listener sits on the form itself, so it runs
         at the target phase — before the document-level AJAX cart handler. */
      var form = input.closest('form');
      if (!form) return;
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (event) {
        if (validateForm(form)) {
          /* An empty file input would still post a blank "Pet Photo" part.
             Disable it for this tick so the AJAX handler's FormData (built
             right after this listener) leaves it out entirely. */
          if (photoInput && !(photoInput.files && photoInput.files.length)) {
            photoInput.disabled = true;
            setTimeout(function () { photoInput.disabled = false; }, 0);
          }
          /* Photo-only order: same trick keeps a blank "Pet's Name" off the line. */
          if (photoInput && !isValid(input.value)) {
            input.disabled = true;
            setTimeout(function () { input.disabled = false; }, 0);
          }
          return;
        }
        event.preventDefault();
        event.stopPropagation();
      });
    }

    function initAll() {
      var nodes = document.querySelectorAll('[data-petname]');
      for (var i = 0; i < nodes.length; i++) initPetName(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sale-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function start(el) {
      if (el.dataset.cdReady === '1') return;
      el.dataset.cdReady = '1';
      var end = parseInt(el.dataset.end, 10) * 1000;
      if (!end) { el.remove(); return; }
      var d = el.querySelector('[data-cd-d]'), dn = el.querySelector('[data-cd-dn]');
      var h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
      var timer = 0;
      function paint() {
        var left = Math.floor((end - Date.now()) / 1000);
        /* Over: gone for good, no rollover. */
        if (left <= 0) { clearTimeout(timer); el.remove(); return; }
        var days = Math.floor(left / 86400); left -= days * 86400;
        d.hidden = days === 0;
        dn.textContent = days;
        h.textContent = pad(Math.floor(left / 3600));
        m.textContent = pad(Math.floor(left % 3600 / 60));
        s.textContent = pad(left % 60);
        /* Tick on the second boundary so it never skips or stutters. */
        timer = setTimeout(paint, 1000 - (Date.now() % 1000) + 5);
      }
      paint();
    }
    function all() { document.querySelectorAll('[data-sale-countdown]').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chart"] && !Shopify.designMode) return;
  try {
    /* Size-chart modal: open, close (button / overlay / Esc) and a focus trap so
     keyboard and screen-reader users cannot tab out into the page behind. */
  (function () {
    function init(root) {
      if (root.dataset.scReady === '1') return;
      root.dataset.scReady = '1';
      var opener = root.querySelector('[data-sizechart-open]');
      var modal = root.querySelector('[data-sizechart-modal]');
      if (!opener || !modal) return;
      var lastFocus = null;

      function focusables() {
        return Array.prototype.filter.call(
          modal.querySelectorAll('button, a[href], img[tabindex]'),
          function (el) { return el.offsetParent !== null; }
        );
      }
      function open() {
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var f = focusables();
        if (f.length) f[0].focus();
      }
      function close() {
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      opener.addEventListener('click', open);
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-sizechart-close]')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (modal.hidden) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    function initAll() {
      var nodes = document.querySelectorAll('.sizechart');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
